/*
 * @Author: zhangsheng
 * @Date: 2023-09-18 13:19:34
 * @LastEditors: zhangsheng
 * @LastEditTime: 2025-12-23 09:38:41
 * @FilePath: \panda-index-sicermem-frontend - 副本\src\locales\en-US\aboutUs.ts
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
export default {
	"About.index.424704-0": "AppKit Landing is a perfect landing page template",
	"About.index.424704-1": "For your project",
	"About.index.424704-2": "It can help you build beautiful and effective landing pages to promote your products or side projects!",
	"About.index.424704-3": "Bootstrap enthusiast?",
	"About.index.424704-4": "AppKit Landing is built on Bootstrap 5 and SASS, making it easy and fast to customize!",
	"About.index.424704-5": "Are you ready to create an excellent product?",
	"About.index.424704-6": "Get AppKit Landing now, it will help you effectively promote your product!",
	"About.index.424704-7": "Why use AppKit Landing?",
	"About.index.424704-8": "Appkit Landing adopts modern front-end technology and includes a large number of practical components and widgets to accelerate your development speed.",
	"About.index.424704-9": "Software development services",
	"About.index.424704-10": "Provide available software development services, with development platforms covering sports applications, website systems, mini programs, etc",
	"About.index.424704-11": "Digital Strategy Consulting",
	"About.index.424704-12": "artificial intelligence technology",
	"About.index.424704-13": "Building sustainable competitive advantages in the digital age and enhancing the core competitiveness of enterprises",
	"About.index.424704-14": "Deeply cultivating the research and application of artificial intelligence technology, providing professional services such as AI scenario customization, intelligent algorithm optimization, and digital capability upgrading for enterprises, helping them reduce costs and increase efficiency, and achieve intelligent transformation"
};
